import {AxiosResponse} from 'axios'
import {GetRequest, Photo} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface Get<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const get: Get<GetRequest, Photo> = (http, params) => {
  const {ClientID, ID} = params

  const path = '/v1/photos/{id}'.replace('{id}', ID.toString())

  return http.request<Photo>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}`,
  })
}
